import React from "react";

/** Infinite horizontal ticker. Items are duplicated so the loop is seamless. */
export default function Marquee({ label, items }) {
  const loop = [...items, ...items];
  return (
    <section className="marquee-wrap" aria-label={label}>
      {label && <p>{label}</p>}
      <div className="marquee">
        {loop.map((item, i) => <span key={`${item}-${i}`}>{item}</span>)}
      </div>
    </section>
  );
}
